export const uniqueIdGenerator =  () => Math.random().toString(36).substr(2, 10);